import {
    ActionsPanel_ShareAsLink_MultipleFilesText,
    ActionsPanel_ShareAsLink_SingleFileText,
} from './getShareStringsForActionPanel.locstring.json';
import {
    ActionsPanel_UploadAndShareLink_MultipleFilesText,
    ActionsPanel_UploadAndShareLink_SingleFileText,
    ActionsPanel_UploadAndShareLinkTextDescriptionText,
    ActionsPanel_ShareAsProviderLink_MultipleFilesText,
    ActionsPanel_ShareAsProviderLink_SingleFileText,
    ActionsPanel_ShareAsProviderLinkTextDescriptionText,
} from '../../strings.locstring.json';
import { ActionsPanel_DefaultUploadFolderName } from 'owa-locstrings/lib/strings/actionspanel_defaultuploadfoldername.locstring.json';
import loc, { format } from 'owa-localize';
import FilePickerUploadConfiguration from '../../store/schema/FilePickerUploadConfiguration';

import { isNullOrWhiteSpace } from 'owa-string-utils';
import { SelectedFilesSource } from '../../types/FilePickerResult';

// The first string of shareButton array is be the button's text and the second string is its description.
export interface ShareButtonStrings {
    shareText: string;
    shareDescription: string;
}

export default function getShareStringsForActionPanel(
    filesSource: SelectedFilesSource,
    isMultipleSelection: boolean,
    providerDisplayName: string,
    uploadConfiguration: FilePickerUploadConfiguration | null
): ShareButtonStrings {
    let shareButton: ShareButtonStrings;
    if (filesSource === SelectedFilesSource.LocalComputerFiles) {
        let folderName = uploadConfiguration ? uploadConfiguration.folderName : null;
        if (isNullOrWhiteSpace(folderName)) {
            folderName = loc(ActionsPanel_DefaultUploadFolderName);
        }
        let uploadText = uploadConfiguration ? uploadConfiguration.uploadText : null;
        if (isNullOrWhiteSpace(uploadText)) {
            uploadText = format(
                isMultipleSelection
                    ? loc(ActionsPanel_UploadAndShareLink_MultipleFilesText)
                    : loc(ActionsPanel_UploadAndShareLink_SingleFileText),
                providerDisplayName
            );
        }

        shareButton = {
            shareText: uploadText,
            shareDescription: format(
                loc(ActionsPanel_UploadAndShareLinkTextDescriptionText),
                folderName
            ),
        };
    } else {
        let shareText: string;
        if (isNullOrWhiteSpace(providerDisplayName)) {
            shareText = isMultipleSelection
                ? loc(ActionsPanel_ShareAsLink_MultipleFilesText)
                : loc(ActionsPanel_ShareAsLink_SingleFileText);
        } else {
            shareText = format(
                isMultipleSelection
                    ? loc(ActionsPanel_ShareAsProviderLink_MultipleFilesText)
                    : loc(ActionsPanel_ShareAsProviderLink_SingleFileText),
                providerDisplayName
            );
        }
        shareButton = {
            shareText: shareText,
            shareDescription: loc(ActionsPanel_ShareAsProviderLinkTextDescriptionText),
        };
    }

    return shareButton;
}
